// actions.ts
import { Context, IActions} from './actions.types'
import { RootState } from '@/store/types'
import { IvalidationData,validationData} from '@/entities'
import { ActionTree } from 'vuex';


export const actions: IActions = {
    setValidation(context: Context,payload)
    {

        return this.$services.application.getValidationData(payload.id,this.$services.application.transformAppData(payload.data)).then(data=>{
            context.commit('setValidationData',data);
            return data
        })
    }
}